import { useLayoutEffect, useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/naming-convention
const useLayoutEffect_SAFE_FOR_SSR = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

export { useLayoutEffect_SAFE_FOR_SSR };
